import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';
import { Context } from '../context/AuthContext';
import Swal from 'sweetalert2';
import ApiUsuario from '../services/usuarioService';

const GlobalStyles = createGlobalStyle`
  .react-parallax-bgimage {
    transform: translate3d(-50%, 0, 0px) !important;
  }
  .h-100 {
    height: 100vh !important;
  }
`;

export default function Home() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const { handleLogin, loading } = useContext(Context);
  const navigate = useNavigate();

   function handleSubmit(event) {
    event.preventDefault();
    if (!email || (!isForgotPassword && !password)) {
      Swal.fire({
        text: 'Por favor, preencha todos os campos.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      });
      return;
    }

    if (isForgotPassword) {
      // Aqui você pode chamar a função que envia o e-mail de recuperação
      Swal.fire({
        text: 'Se o e-mail estiver cadastrado, um link de recuperação foi enviado.',
        icon: 'info',
        confirmButtonText: 'Ok',
      });
      ApiUsuario.resetPassword(email);
    } else {
      handleLogin(email, password, navigate);
    }
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader)
        setTimeout(() => {
          loader.classList.add("fadeOut");
          loader.style.display = 'none';
        }, 600);
    }
  }, []);

  return (
    <>
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Fetron - Federação de Taekwondô de Rondônia</title>
      </Helmet>

      <GlobalStyles />

      <div id='mainpreloader'>
        <Preloader />
      </div>

      <div className="home dark-scheme">
        <header id="header-wrap">
          <Navbar />
        </header>

        <section className="no-bg">
          <div className="row align-items-center">
            <div>
              <img src="../../img/background/bg-header.png" width="100%" alt="Background" />
            </div>
            <div className="col-lg-4 offset-lg-4">
              <div className="spacer-10"></div>
              <div className="padding40 rounded-10 shadow-soft bg-white-1 mb-5" id="login">
                <div className="text-center">
                  <h4>{isForgotPassword ? "Recuperar Senha" : "Acessar sua conta"}</h4>
                </div>
                <div className="spacer-10"></div>
                <form id="form_auth" className="form-border">
                  <div className="field-set">
                    <label>Email</label>
                    <input
                      type='email'
                      placeholder="Digite o seu email"
                      onChange={event => setEmail(event.target.value)}
                      className="form-control"
                    />
                  </div>

                  {!isForgotPassword && (
                    <div className="field-set">
                      <label>Senha</label>
                      <input
                        type='password'
                        placeholder="Digite sua senha"
                        onChange={event => setPassword(event.target.value)}
                        className="form-control"
                      />
                    </div>
                  )}

                  <div className="spacer-20"></div>
                  <div id="submit">
                    <button
                      onClick={handleSubmit}
                      className="btn-main btn-fullwidth rounded-3"
                      disabled={loading}
                    >
                      {loading ? 'Carregando...' : isForgotPassword ? 'Recuperar Senha' : 'Login'}
                    </button>
                  </div>

                  <div className="spacer-10"></div>
                  <div className="text-center">
                    {isForgotPassword ? (
                      <span className="titulo" onClick={() => setIsForgotPassword(false)}>
                        Voltar ao login
                      </span>
                    ) : (
                      <span className="titulo" onClick={() => setIsForgotPassword(true)}>
                        Esqueci minha senha
                      </span>
                    )}

                    <span className="titulo">
                      <Link to="/cadastrar-atleta">
                        Novo Cadastro
                      </Link>
                    </span>

                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
      <ScrollToTopBtn />
    </>
  );
}
